import { render, staticRenderFns } from "./AddGoods.vue?vue&type=template&id=7094cb0c&scoped=true"
import script from "./AddGoods.vue?vue&type=script&lang=js"
export * from "./AddGoods.vue?vue&type=script&lang=js"
import style0 from "./AddGoods.vue?vue&type=style&index=0&id=7094cb0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7094cb0c",
  null
  
)

export default component.exports